import { render, staticRenderFns } from "./15_ap_terminos_facturacion.vue?vue&type=template&id=f4d0a018&scoped=true&"
import script from "./15_ap_terminos_facturacion.vue?vue&type=script&lang=js&"
export * from "./15_ap_terminos_facturacion.vue?vue&type=script&lang=js&"
import style0 from "./15_ap_terminos_facturacion.vue?vue&type=style&index=0&id=f4d0a018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d0a018",
  null
  
)

export default component.exports